import { LAUNCH_VIEW_NAME, SETTINGS_DATA_KEY } from "../../core/constants";
import { getViewData, setViewData } from "../../core/views";

export const loadSettingsFromLS = () : boolean => {

  const settingsJson = localStorage.getItem(SETTINGS_DATA_KEY);
  if (settingsJson == null) {
    return false;
  }

  const settingsData = JSON.parse(settingsJson);
  const launchViewData = getViewData(LAUNCH_VIEW_NAME);
  if (launchViewData.data?.settings !== undefined) return true;

  launchViewData.data = {
    settings : settingsData
  }
  console.log('set launch settings', launchViewData)
  setViewData(LAUNCH_VIEW_NAME, launchViewData);
  return true;
}

export function saveSettingsToLS(settings : any) {
  if (settings == null) {
    return;
  }

  const settingsJson = JSON.stringify(settings);
  localStorage.setItem(SETTINGS_DATA_KEY, settingsJson);
}
